import React, { useEffect, useState } from "react";
import { leadSourceOptions } from "../lib/leadSource";

// "How did you hear about us?" — the same question, worded the same way, on the
// pricing tool, the guide forms, the Discovery Call box and the contact form.
// Changing the dropdown clears the follow-up box, so a stale answer can never be
// submitted against the wrong source.
export const LeadSourceField = ({
  value,
  onChange,
  required = false,
  error = "",
  className = "",
  labelClassName = "block text-navy font-semibold",
  inputClassName = "w-full rounded-lg border border-slate-200 bg-white px-3 py-2.5 text-sm text-navy focus:outline-none focus:ring-2 focus:ring-orange/40 focus:border-orange transition-colors",
  testId = "lead-source",
  onOptions,
}) => {
  const [options, setOptions] = useState([]);
  const v = value || { id: "", label: "", detail: "" };

  useEffect(() => {
    let live = true;
    leadSourceOptions().then((o) => {
      if (!live) return;
      setOptions(o);
      if (onOptions) onOptions(o);
    });
    return () => { live = false; };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!options.length) return null;
  const chosen = options.find((o) => o.id === v.id);
  const detail = chosen?.detail?.enabled ? chosen.detail : null;

  return (
    <div className={className} data-testid={`${testId}-field`}>
      <label htmlFor={`${testId}-select`} className={labelClassName}>
        How did you hear about us?{required && <span className="text-orange ml-1">*</span>}
      </label>
      <select
        id={`${testId}-select`}
        value={v.id}
        required={required}
        aria-invalid={error ? "true" : undefined}
        aria-describedby={error ? `${testId}-error` : undefined}
        onChange={(e) => {
          const opt = options.find((o) => o.id === e.target.value);
          onChange({ id: opt?.id || "", label: opt?.label || "", detail: "" });
        }}
        data-testid={`${testId}-select`}
        className={`${inputClassName} mt-2`}
      >
        <option value="">Please select an option</option>
        {options.map((o) => (
          <option key={o.id} value={o.id}>{o.label}</option>
        ))}
      </select>

      {detail && (
        <div className="mt-3" role="group" aria-live="polite">
          <label htmlFor={`${testId}-detail`} className="block text-sm text-slate-600">
            {detail.label}{detail.required && <span className="text-orange ml-1">*</span>}
          </label>
          <input
            id={`${testId}-detail`}
            type="text"
            value={v.detail || ""}
            maxLength={300}
            aria-required={detail.required ? "true" : undefined}
            onChange={(e) => onChange({ ...v, detail: e.target.value })}
            data-testid={`${testId}-detail`}
            className={`${inputClassName} mt-1.5`}
          />
        </div>
      )}

      {error && (
        <p id={`${testId}-error`} className="text-sm text-orange-dark font-semibold mt-2" data-testid={`${testId}-error`}>
          {error}
        </p>
      )}
    </div>
  );
};

export default LeadSourceField;
